const DEFAULT_API_URL = process.env.REACT_APP_APP_ENV !== 'prod' ? 'https://api.qa.proofup.com/api' : 'https://api.proofup.com/api';
export const BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_URL;

export const BYPASS_PLAID = process.env.REACT_APP_BYPASS_PLAID === 'true';
